// This file is auto-generated by @hey-api/openapi-ts

import { queryOptions, useMutation, type UseMutationOptions, useQuery } from '@tanstack/react-query';

import { client } from '../client.gen';
import { acceptRfidInvite, getRfidInvite, getUsersForOrganization, getUsersForOrganizations, type Options, putUserForOrganization, putUserForOrganizations, rejectRfidInvite, removeUserFromOrganization, removeUserFromOrganizations } from '../sdk.gen';
import type { AcceptRfidInviteData, AcceptRfidInviteError, AcceptRfidInviteResponse, GetRfidInviteData, GetRfidInviteError, GetRfidInviteResponse, GetUsersForOrganizationData, GetUsersForOrganizationError, GetUsersForOrganizationResponse, GetUsersForOrganizationsData, GetUsersForOrganizationsError, GetUsersForOrganizationsResponse, PutUserForOrganizationData, PutUserForOrganizationError, PutUserForOrganizationResponse, PutUserForOrganizationsData, PutUserForOrganizationsError, PutUserForOrganizationsResponse, RejectRfidInviteData, RejectRfidInviteError, RejectRfidInviteResponse, RemoveUserFromOrganizationData, RemoveUserFromOrganizationError, RemoveUserFromOrganizationResponse, RemoveUserFromOrganizationsData, RemoveUserFromOrganizationsError, RemoveUserFromOrganizationsResponse } from '../types.gen';

/**
 * List users for multiple organizations
 *
 * Aggregates users across all charge systems connected to the organizations identified by organizationIds
 */
export const getUsersForOrganizationsMutation = (options?: Partial<Options<GetUsersForOrganizationsData>>): UseMutationOptions<GetUsersForOrganizationsResponse, GetUsersForOrganizationsError, Options<GetUsersForOrganizationsData>> => {
    const mutationOptions: UseMutationOptions<GetUsersForOrganizationsResponse, GetUsersForOrganizationsError, Options<GetUsersForOrganizationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getUsersForOrganizations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * List users for multiple organizations
 *
 * Aggregates users across all charge systems connected to the organizations identified by organizationIds
 */
export const useGetUsersForOrganizationsMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<GetUsersForOrganizationsResponse, GetUsersForOrganizationsError, Options<GetUsersForOrganizationsData>>, 'mutationFn'>>) => useMutation({ ...getUsersForOrganizationsMutation(), ...mutationOptions });

/**
 * Create or replace a user within multiple organization scopes
 *
 * Upserts the user identified by phone number and adds the user to all charge systems connected to the organizations identified by organizationIds
 */
export const putUserForOrganizationsMutation = (options?: Partial<Options<PutUserForOrganizationsData>>): UseMutationOptions<PutUserForOrganizationsResponse, PutUserForOrganizationsError, Options<PutUserForOrganizationsData>> => {
    const mutationOptions: UseMutationOptions<PutUserForOrganizationsResponse, PutUserForOrganizationsError, Options<PutUserForOrganizationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putUserForOrganizations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create or replace a user within multiple organization scopes
 *
 * Upserts the user identified by phone number and adds the user to all charge systems connected to the organizations identified by organizationIds
 */
export const usePutUserForOrganizationsMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<PutUserForOrganizationsResponse, PutUserForOrganizationsError, Options<PutUserForOrganizationsData>>, 'mutationFn'>>) => useMutation({ ...putUserForOrganizationsMutation(), ...mutationOptions });

/**
 * Remove a user from multiple organizations
 *
 * Removes charge system access for all charge systems connected to the organizations identified by organizationIds
 */
export const removeUserFromOrganizationsMutation = (options?: Partial<Options<RemoveUserFromOrganizationsData>>): UseMutationOptions<RemoveUserFromOrganizationsResponse, RemoveUserFromOrganizationsError, Options<RemoveUserFromOrganizationsData>> => {
    const mutationOptions: UseMutationOptions<RemoveUserFromOrganizationsResponse, RemoveUserFromOrganizationsError, Options<RemoveUserFromOrganizationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeUserFromOrganizations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove a user from multiple organizations
 *
 * Removes charge system access for all charge systems connected to the organizations identified by organizationIds
 */
export const useRemoveUserFromOrganizationsMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<RemoveUserFromOrganizationsResponse, RemoveUserFromOrganizationsError, Options<RemoveUserFromOrganizationsData>>, 'mutationFn'>>) => useMutation({ ...removeUserFromOrganizationsMutation(), ...mutationOptions });

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getUsersForOrganizationQueryKey = (options: Options<GetUsersForOrganizationData>) => createQueryKey('getUsersForOrganization', options);

/**
 * List users for an organization
 *
 * Aggregates users across all charge systems connected to the organization identified by organizationId
 */
export const getUsersForOrganizationQueryOptions = (options: Options<GetUsersForOrganizationData>) => queryOptions<GetUsersForOrganizationResponse, GetUsersForOrganizationError, GetUsersForOrganizationResponse, ReturnType<typeof getUsersForOrganizationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUsersForOrganization({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUsersForOrganizationQueryKey(options)
});

/**
 * List users for an organization
 *
 * Aggregates users across all charge systems connected to the organization identified by organizationId
 */
export const useGetUsersForOrganizationQuery = (options: Options<GetUsersForOrganizationData>) => useQuery(getUsersForOrganizationQueryOptions(options));

/**
 * Removes a user from an organization
 *
 * Removes charge system access for all charge systems connected to the organization identified by organizationId
 */
export const removeUserFromOrganizationMutation = (options?: Partial<Options<RemoveUserFromOrganizationData>>): UseMutationOptions<RemoveUserFromOrganizationResponse, RemoveUserFromOrganizationError, Options<RemoveUserFromOrganizationData>> => {
    const mutationOptions: UseMutationOptions<RemoveUserFromOrganizationResponse, RemoveUserFromOrganizationError, Options<RemoveUserFromOrganizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeUserFromOrganization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Removes a user from an organization
 *
 * Removes charge system access for all charge systems connected to the organization identified by organizationId
 */
export const useRemoveUserFromOrganizationMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<RemoveUserFromOrganizationResponse, RemoveUserFromOrganizationError, Options<RemoveUserFromOrganizationData>>, 'mutationFn'>>) => useMutation({ ...removeUserFromOrganizationMutation(), ...mutationOptions });

/**
 * Create or replace a user within an organization scope
 *
 * Upserts the user identified by phone number and adds the user to all charge systems connected to the organization identified by organizationId
 */
export const putUserForOrganizationMutation = (options?: Partial<Options<PutUserForOrganizationData>>): UseMutationOptions<PutUserForOrganizationResponse, PutUserForOrganizationError, Options<PutUserForOrganizationData>> => {
    const mutationOptions: UseMutationOptions<PutUserForOrganizationResponse, PutUserForOrganizationError, Options<PutUserForOrganizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putUserForOrganization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create or replace a user within an organization scope
 *
 * Upserts the user identified by phone number and adds the user to all charge systems connected to the organization identified by organizationId
 */
export const usePutUserForOrganizationMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<PutUserForOrganizationResponse, PutUserForOrganizationError, Options<PutUserForOrganizationData>>, 'mutationFn'>>) => useMutation({ ...putUserForOrganizationMutation(), ...mutationOptions });

export const getRfidInviteQueryKey = (options: Options<GetRfidInviteData>) => createQueryKey('getRfidInvite', options);

/**
 * Get an RFID invite by token
 *
 * Returns the pending RFID claim invitation details for a magic-link token
 */
export const getRfidInviteQueryOptions = (options: Options<GetRfidInviteData>) => queryOptions<GetRfidInviteResponse, GetRfidInviteError, GetRfidInviteResponse, ReturnType<typeof getRfidInviteQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRfidInvite({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRfidInviteQueryKey(options)
});

/**
 * Get an RFID invite by token
 *
 * Returns the pending RFID claim invitation details for a magic-link token
 */
export const useGetRfidInviteQuery = (options: Options<GetRfidInviteData>) => useQuery(getRfidInviteQueryOptions(options));

/**
 * Accept an RFID invite
 *
 * Accepts the pending RFID claim invitation identified by the magic-link token
 */
export const acceptRfidInviteMutation = (options?: Partial<Options<AcceptRfidInviteData>>): UseMutationOptions<AcceptRfidInviteResponse, AcceptRfidInviteError, Options<AcceptRfidInviteData>> => {
    const mutationOptions: UseMutationOptions<AcceptRfidInviteResponse, AcceptRfidInviteError, Options<AcceptRfidInviteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await acceptRfidInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Accept an RFID invite
 *
 * Accepts the pending RFID claim invitation identified by the magic-link token
 */
export const useAcceptRfidInviteMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<AcceptRfidInviteResponse, AcceptRfidInviteError, Options<AcceptRfidInviteData>>, 'mutationFn'>>) => useMutation({ ...acceptRfidInviteMutation(), ...mutationOptions });

/**
 * Reject an RFID invite
 *
 * Rejects the pending RFID claim invitation identified by the magic-link token
 */
export const rejectRfidInviteMutation = (options?: Partial<Options<RejectRfidInviteData>>): UseMutationOptions<RejectRfidInviteResponse, RejectRfidInviteError, Options<RejectRfidInviteData>> => {
    const mutationOptions: UseMutationOptions<RejectRfidInviteResponse, RejectRfidInviteError, Options<RejectRfidInviteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rejectRfidInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject an RFID invite
 *
 * Rejects the pending RFID claim invitation identified by the magic-link token
 */
export const useRejectRfidInviteMutation = (mutationOptions?: Partial<Omit<UseMutationOptions<RejectRfidInviteResponse, RejectRfidInviteError, Options<RejectRfidInviteData>>, 'mutationFn'>>) => useMutation({ ...rejectRfidInviteMutation(), ...mutationOptions });
